import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import employeeApi from '../../lib/employeeApi';
import EmployeeLayout from '../../components/EmployeeLayout';

export default function TeamPage() {
  const [employees, setEmployees] = useState([]);
  const [showSensitive, setShowSensitive] = useState({});

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const res = await employeeApi.get('/api/employees');
        setEmployees(res.data);
      } catch (error) {
        toast.error('Failed to load team');
      }
    };
    fetchEmployees();
  }, []);

  return (
    <EmployeeLayout>
      <div className="p-8">
        <h1 className="text-2xl font-bold text-navy-900 mb-6">Team Members</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {employees.map((emp) => (
            <Link key={emp._id} to={`/employee/team/${emp._id}`} className="bg-white rounded-xl border border-charcoal-200 p-6 hover:border-pink-500 hover:shadow-lg transition-all">
              <h3 className="font-semibold text-charcoal-900">{emp.personal?.full_name || emp.work_email}</h3>
              <p className="text-sm text-charcoal-600">{emp.employment?.designation}</p>
              <div className="flex flex-wrap gap-1 mt-2">
                {(emp.employment?.departments || []).map((dept, i) => (
                  <span key={i} className="px-2 py-1 bg-charcoal-100 text-charcoal-700 rounded-xl text-xs">{dept}</span>
                ))}
              </div>
              <p className="text-xs text-neutral-500 mt-2">{emp.employment?.employee_id}</p>
            </Link>
          ))}
        </div>
      </div>
    </EmployeeLayout>
  );
}